import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as OAuthActions from "../../actions/oauthActions";
import * as constants from "../../constants";

const refreshOAuthCodeLogic = createLogic({
	type: ActionTypes.REFRESH_ACCESS_TOKEN,
	// eslint-disable-next-line no-unused-vars
	process({ action }, dispatch, done) {
		dispatch(ControlPanelActions.showLoading());
		firebase
			.auth()
			.currentUser.getIdToken()
			.then(token => {
				const api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				const { payload: data } = action;
				api.post("/oauth/2.0/refresh", data)
					.then(res => {
						dispatch(OAuthActions.refreshAccessTokenSuccess(res.data));
					})
					.catch(error => {
						dispatch(ControlPanelActions.displayError(error.message));
						dispatch(OAuthActions.refreshAccessTokenFailure(error.response.data.Message));
					})
					.finally(() => {
						dispatch(ControlPanelActions.hideLoading());
						done();
					});
			});
	},
});

export default [refreshOAuthCodeLogic];
